module.exports = __webpack_public_path__ + "img/angle-top-green.3c52ac79.svg";